import React from 'react';


export default function TruncatedText({
                                          text,
                                          maxLength = 50,
                                          className = 'tw-text-sm',
                                          emptyText = '-',
                                          emptyClassName = 'tw-text-gray-400',
                                      }) {
    if (!text) return <span className={`${className} ${emptyClassName}`}>{emptyText}</span>;
    const displayText = text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
    return (
        <span className={className} title={text}>
{displayText}
</span>
    );
}
